export function formatterEvent(arr, val) {
  const obj = arr.find(item => {
    return item.value == val;
  });
  return (obj && obj.label) || val;
}
